"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.frameConfig = exports.defaultFrameStyle = void 0;
var tslib_1 = require("tslib");
var defaultConfig = {
    title: "Oniroco widget",
    src: process.env.WIDGET_URL || "https://widget.oniroco.app",
};
exports.defaultFrameStyle = {
    title: "chat",
    zIndex: "2147483647",
    "z-index": "2147483647",
    position: "fixed",
    bottom: "0",
    right: "0",
    left: "auto",
    top: "auto",
    height: "0",
    width: "0",
    border: "none",
    display: "none",
};
exports.frameConfig = {
    default: tslib_1.__assign(tslib_1.__assign({ id: "ch_widget" }, defaultConfig), { style: {
            "z-index": "2147483647",
            position: "fixed",
            bottom: "0",
            right: "0",
            left: "auto",
            top: "auto",
            height: "90px",
            minHeight: "90px",
            width: "100px",
            border: "none",
            display: "block",
            overflow: "hidden",
            "border-radius": "50%",
        } }),
    widget: tslib_1.__assign(tslib_1.__assign({ id: "ch_widget" }, defaultConfig), { style: {
            "z-index": "2147483647",
            position: "fixed",
            bottom: "0",
            right: "0",
            left: "auto",
            top: "auto",
            height: "90px",
            minHeight: "90px",
            width: "100px",
            border: "none",
            display: "block",
            overflow: "hidden",
            "border-radius": "50%",
        } }),
    embed: tslib_1.__assign(tslib_1.__assign({ id: "ch_embed_widget" }, defaultConfig), { style: {
            height: "100%",
            width: "100%",
            border: "none",
            display: "block",
            overflow: "hidden",
        } }),
    aiForm: {
        id: "ch_embed_widget",
        src: process.env.AI_FORM_CLIENT_URL || "https://ai-form-client.chathive.app",
        style: {
            height: "100%",
            width: "100%",
            border: "none",
            display: "block",
            overflow: "hidden",
            backgroundColor: "transparent",
        },
    },
};
exports.default = {};
